//import { useLocalizeField } from "~/l10n";

export function ExitMieterhoehungZugestimmt() {
  //const l = useLocalizeField();

  return (
    <>
      <h2>
        Leider können wir dir nicht weiterhelfen, weil du der Mieterhöhung
        bereits zugestimmt hast.
      </h2>
      <p>
        Es ist sehr schwer eine Mieterhöhung rückgängig zu machen, der du ihr
        bereits zugestimmt hast. Das gilt auch, wenn die Erhöhung nicht
        rechtmäßig war und du jetzt eine zu hohe Miete zahlst.
      </p>
      <h3>Was nun?</h3>
      <p>
        Unter Umständen kann es sich trotzdem lohnen, die Mieterhöhung bei einer
        kostenlosen Mietberatung überprüfen zu lassen.
      </p>
      <p>
        Wenn du die nächste Mieterhöhung bekommst, lass sie prüfen, bevor du
        zustimmst.
      </p>
    </>
  );
}
